export default {"src":"/app/_next/static/media/hands-2.91f3cca2.svg","height":398,"width":398,"blurWidth":0,"blurHeight":0};